import { AttachmentsZone, FormGetter, Grid, FormSetter } from '@kirz/mui-admin';
import { Grid2Props } from '@mui/material';
import React from 'react';

export type FilesFieldProps = {
  name: string;
  title: string;
} & Grid2Props;

export function FilesField({ name, title, ...props }: FilesFieldProps) {
  return (
    <FormGetter
      names={[name]}
      render={({ [name]: value }) => {
        return (
          <FormSetter
            render={(setValue) => {
              return (
                <Grid
                  xs={12}
                  md={9}
                  sx={{
                    mt: -2,
                    '& label': {
                      backgroundColor: '#fafafa',
                    },
                    h6: {
                      fontSize: '0.875rem',
                      color: '#65748B',
                      mb: -1.5,
                      fontWeight: 400,
                    },
                  }}
                  {...(props as any)}
                >
                  <AttachmentsZone
                    name=""
                    value={value ?? []}
                    entityId={{}}
                    title={title}
                    attachmentsTypes={[
                      {
                        value: 'other',
                        text: 'Anders',
                      },
                    ]}
                    onFilesChange={(files) => {
                      setValue(name, files);
                    }}
                    grid={false}
                  />
                </Grid>
              );
            }}
          />
        );
      }}
    />
  );
}
